import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import CheckBox from "../../form/CheckBox";
import {is_string} from "locutus/php/var";

class urlFieldForm extends React.Component {

    render() {
        return (
            <Fragment>
                <div className="col-md-7">
                    <div className="form-group">
                        {this.props.presets.component_id ? <TextInput
                            name="url"
                            value={this.props.values.url}
                            label="Url"
                            disabled={this.props.generate}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("url")}
                        /> : <div className="form-group">
                            <label className="control-label">Url</label>
                            <div className="form-control">Kérlek mentsd el az url létrehozásához!</div>
                        </div>}
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        <label className="control-label">&nbsp;</label>
                        <CheckBox
                            name="public"
                            value={this.props.values.public}
                            disabled={!this.props.values[this.props.componentConfig.idfield]}
                            label="Publikus"
                            saveChanges={(field, value) => {
                                if (is_string(this.props.values.public)) {
                                    value = !!value ? "1" : "0";
                                }
                                this.props.setFieldValue(field, value);
                            }}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default createForm(urlFieldForm);
